<template>
  <v-row no-gutters>
    <v-col cols="auto" class="user-text-bubble chat-widget" :style="`background: ${config.main_color}; color: ${config.text_color}`">
      <span style="word-break: break-word" v-html="text"></span>
    </v-col>
  </v-row>
</template>

<script setup>
import global_config from '@/../config.json'
import { ref, defineProps } from 'vue'

const config = ref(global_config)

const { text } = defineProps({
  text: String
})
</script>

<style scope>
.user-text-bubble {
  max-width: 18rem;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #242428;
  border-radius: 0.9375rem 0 0.9375rem 0.9375rem;
  padding: 0.75rem !important;
}
</style>
